const crashGamesIds = ['5811', '5875', '5687', '5344', '5525', '5781', '5891', '5831', '5643'];

const tabs = {
  1: 'popular',
  2: 'roulette',
  3: 'slotMachines',
  4: 'lotto',
  5: 'cardGames',
};

const tabPairs = {
  1: ['Hight Strike', 'Seven & Fruits', 'Egypt Gods', 'Candy Dreams', 'European Roulette', 'Football Manager'],
  2: ['American Roulette 3D Classic', 'European Roulette', 'French Roulette Classic'],
  3: [],
  4: ['Book Of Keno', 'Xmas Keno Cat'],
  5: [
    'BlackJack Lucky Sevens',
    'Oasis Poker Classic',
    'Baccarat 777',
    'Poker Teen Patti',
    'Texas Holdem Poker',
    'Texas Holdem Bonus',
  ],
};

function getTab(name, id) {
  const targetPair = Object.entries(tabPairs).find(pair => pair[1].includes(name));
  const extraTabs = crashGamesIds.includes(id) ? ['crash'] : [];

  if (!targetPair) return [...extraTabs];

  const tabId = targetPair[0];
  const tab = tabs[tabId];

  return [tab, ...extraTabs];
}

export { getTab };
